var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V5C22 5.55228 21.5523 6 21 6H3C2.44772 6 2 5.55228 2 5V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17H4C3.44772 17 3 16.5523 3 16V7.5H21V16C21 16.5523 20.5523 17 20 17H12.75V19.5365L16.3354 21.3292C16.7059 21.5144 16.8561 21.9649 16.6708 22.3354C16.4856 22.7059 16.0351 22.8561 15.6646 22.6708L12 20.8385L8.33541 22.6708C7.96493 22.8561 7.51442 22.7059 7.32918 22.3354C7.14394 21.9649 7.29411 21.5144 7.66459 21.3292L11.25 19.5365V17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.0f592a0d44c1ee2c63c39cd0ee99c476.svg";
export { ForwardRef as ReactComponent };